// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7deb253b","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"fc41c77e","726":"42d1d312"}[chunkId] + ".chunk.js";
};